import { useState, useEffect } from 'react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const inp = { width:'100%', padding:'9px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', boxSizing:'border-box', fontSize:'.9rem' };
const lbl = { display:'block', fontWeight:600, fontSize:'.8rem', marginBottom:5, color:'#374151' };
const card = { background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:24, marginBottom:20 };

const MASK = '••••••••';

const SMTP_PRESETS = [
  { label:'Gmail',       host:'smtp.gmail.com',         port:587 },
  { label:'Outlook/Hotmail', host:'smtp.office365.com', port:587 },
  { label:'Zoho Mail',   host:'smtp.zoho.com',          port:587 },
  { label:'Yahoo',       host:'smtp.mail.yahoo.com',    port:587 },
  { label:'SendGrid',    host:'smtp.sendgrid.net',      port:587 },
  { label:'Brevo',       host:'smtp-relay.brevo.com',   port:587 },
  { label:'Personalizado', host:'',                     port:587 },
];

export default function AdminSettings() {
  const [activeTab, setActiveTab] = useState('email');
  const [loading, setLoading]     = useState(true);
  const [saving, setSaving]       = useState(false);
  const [testing, setTesting]     = useState(false);
  const [testEmail, setTestEmail] = useState('');

  const [email, setEmail] = useState({
    mail_host:'', mail_port:'587', mail_user:'', mail_pass:'',
    mail_from:'', mail_from_name:'AutoFlow',
  });
  const [mp, setMp] = useState({
    mp_access_token:'', mp_public_key:'', mp_webhook_secret:'', mp_mode:'production',
  });
  const [status, setStatus] = useState({ mail_configured: false, mp_configured: false, mp_webhook_url: '' });

  const load = async () => {
    setLoading(true);
    try {
      const r = await adminAPI.settings();
      const d = r.data.data;
      setEmail({
        mail_host:      d.mail_host      || 'smtp.gmail.com',
        mail_port:      d.mail_port      || '587',
        mail_user:      d.mail_user      || '',
        mail_pass:      d.mail_pass      || '',
        mail_from:      d.mail_from      || '',
        mail_from_name: d.mail_from_name || 'AutoFlow',
      });
      setMp({
        mp_access_token:   d.mp_access_token   || '',
        mp_public_key:     d.mp_public_key     || '',
        mp_webhook_secret: d.mp_webhook_secret || '',
        mp_mode:           d.mp_mode           || 'production',
      });
      setStatus({
        mail_configured: d.mail_configured,
        mp_configured:   d.mp_configured,
        mp_webhook_url:  d.mp_webhook_url || '',
      });
    } catch { toast.error('Erro ao carregar configurações.'); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const saveEmail = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminAPI.updateSettings(email);
      toast.success('Configurações de e-mail salvas!');
      load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
    finally { setSaving(false); }
  };

  const saveMp = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminAPI.updateSettings(mp);
      toast.success('Configurações do Mercado Pago salvas!');
      load();
    } catch (err) { toast.error(err.response?.data?.message || 'Erro.'); }
    finally { setSaving(false); }
  };

  const runTestEmail = async () => {
    if (!testEmail) { toast.error('Informe o e-mail de destino.'); return; }
    setTesting(true);
    try {
      const r = await adminAPI.testEmail({ email: testEmail });
      toast.success(r.data.message || 'E-mail enviado!');
    } catch (err) { toast.error(err.response?.data?.message || 'Falha no envio.'); }
    finally { setTesting(false); }
  };

  const applyPreset = (preset) => {
    if (preset.host) setEmail(e => ({ ...e, mail_host: preset.host, mail_port: String(preset.port) }));
  };

  const Dot = ({ ok }) => (
    <span style={{ display:'inline-block', width:8, height:8, borderRadius:'50%', background: ok ? '#10B981' : '#9CA3AF', marginRight:6 }} />
  );

  if (loading) return <div style={{ padding:40, textAlign:'center', color:'#6B7280' }}>Carregando...</div>;

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Configurações do Sistema</h1>
        <div style={{ display:'flex', gap:12 }}>
          <span style={{ fontSize:'.8rem', color:'#6B7280', display:'flex', alignItems:'center' }}>
            <Dot ok={status.mail_configured} />E-mail {status.mail_configured ? 'configurado' : 'não configurado'}
          </span>
          <span style={{ fontSize:'.8rem', color:'#6B7280', display:'flex', alignItems:'center' }}>
            <Dot ok={status.mp_configured} />MP {status.mp_configured ? 'configurado' : 'não configurado'}
          </span>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display:'flex', gap:0, borderBottom:'2px solid #E5E7EB', marginBottom:24 }}>
        {[['email','E-mail SMTP'],['mercadopago','Mercado Pago']].map(([t,l]) => (
          <button key={t} onClick={()=>setActiveTab(t)}
            style={{ padding:'10px 24px', background:'none', border:'none', cursor:'pointer', fontWeight:700, fontSize:'.9rem',
              color: activeTab===t?'#2563EB':'#6B7280',
              borderBottom: activeTab===t?'2px solid #2563EB':'2px solid transparent', marginBottom:-2 }}>
            {l}
          </button>
        ))}
      </div>

      {/* ── Tab E-mail ────────────────────────── */}
      {activeTab === 'email' && (
        <div>
          <div style={card}>
            <h2 style={{ fontWeight:700, fontSize:'1rem', color:'#0F172A', marginBottom:4 }}>Configuração SMTP</h2>
            <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:16 }}>
              Configure o servidor de e-mail usado para envio de confirmações, lembretes e notificações do sistema.
            </p>

            {/* Presets */}
            <div style={{ marginBottom:18 }}>
              <label style={lbl}>Provedor de e-mail</label>
              <div style={{ display:'flex', flexWrap:'wrap', gap:8 }}>
                {SMTP_PRESETS.map(p => (
                  <button key={p.label} type="button" onClick={() => applyPreset(p)}
                    style={{ padding:'6px 14px', border:'1.5px solid', borderRadius:8, cursor:'pointer', fontSize:'.8rem', fontWeight:600,
                      borderColor: email.mail_host === p.host && p.host ? '#2563EB' : '#E5E7EB',
                      background:  email.mail_host === p.host && p.host ? '#EFF6FF' : '#fff',
                      color:       email.mail_host === p.host && p.host ? '#2563EB' : '#374151' }}>
                    {p.label}
                  </button>
                ))}
              </div>
            </div>

            <form onSubmit={saveEmail}>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 140px', gap:14, marginBottom:14 }}>
                <div>
                  <label style={lbl}>Servidor SMTP (host) *</label>
                  <input value={email.mail_host} onChange={e=>setEmail(m=>({...m,mail_host:e.target.value}))} required style={inp} placeholder="smtp.gmail.com" />
                </div>
                <div>
                  <label style={lbl}>Porta *</label>
                  <input value={email.mail_port} onChange={e=>setEmail(m=>({...m,mail_port:e.target.value}))} required style={inp} placeholder="587" />
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:14 }}>
                <div>
                  <label style={lbl}>Usuário / E-mail *</label>
                  <input value={email.mail_user} onChange={e=>setEmail(m=>({...m,mail_user:e.target.value}))} required style={inp} placeholder="seu@email.com" />
                </div>
                <div>
                  <label style={lbl}>Senha / App Password *</label>
                  <input type="password" value={email.mail_pass} onChange={e=>setEmail(m=>({...m,mail_pass:e.target.value}))}
                    style={inp} placeholder={email.mail_pass === MASK ? 'Deixe em branco para manter' : ''} />
                </div>
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:14, marginBottom:20 }}>
                <div>
                  <label style={lbl}>E-mail remetente (From)</label>
                  <input value={email.mail_from} onChange={e=>setEmail(m=>({...m,mail_from:e.target.value}))} style={inp} placeholder="noreply@autoflow.com.br" />
                </div>
                <div>
                  <label style={lbl}>Nome remetente</label>
                  <input value={email.mail_from_name} onChange={e=>setEmail(m=>({...m,mail_from_name:e.target.value}))} style={inp} placeholder="AutoFlow" />
                </div>
              </div>

              <div style={{ background:'#F0FDF4', border:'1px solid #BBF7D0', borderRadius:8, padding:'10px 14px', marginBottom:20, fontSize:'.8rem', color:'#065F46' }}>
                <strong>Gmail:</strong> Use uma <em>App Password</em> (não sua senha normal). Em Conta Google → Segurança → Verificação em 2 etapas → Senhas de app.
                Porta <strong>587</strong> com STARTTLS (recomendado) ou <strong>465</strong> com SSL.
              </div>

              <button type="submit" disabled={saving}
                style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity:saving?.7:1, marginRight:12 }}>
                {saving ? 'Salvando...' : 'Salvar E-mail'}
              </button>
            </form>
          </div>

          {/* Test email */}
          <div style={card}>
            <h2 style={{ fontWeight:700, fontSize:'1rem', color:'#0F172A', marginBottom:4 }}>Testar Envio</h2>
            <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:14 }}>
              Envie um e-mail de teste para verificar se as configurações SMTP estão corretas.
            </p>
            <div style={{ display:'flex', gap:10 }}>
              <input value={testEmail} onChange={e=>setTestEmail(e.target.value)}
                placeholder="seu@email.com" type="email"
                style={{ ...inp, flex:1 }} />
              <button onClick={runTestEmail} disabled={testing || !testEmail}
                style={{ padding:'9px 20px', background:'#059669', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity:(testing||!testEmail)?.7:1, whiteSpace:'nowrap' }}>
                {testing ? 'Enviando...' : 'Enviar Teste'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Tab Mercado Pago ──────────────────── */}
      {activeTab === 'mercadopago' && (
        <div>
          <div style={card}>
            <h2 style={{ fontWeight:700, fontSize:'1rem', color:'#0F172A', marginBottom:4 }}>Credenciais Mercado Pago</h2>
            <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:16 }}>
              Configure as credenciais da sua conta Mercado Pago para processar pagamentos PIX e cartão de crédito.
            </p>

            <div style={{ background:'#EFF6FF', border:'1px solid #BFDBFE', borderRadius:8, padding:'12px 16px', marginBottom:20, fontSize:'.82rem', color:'#1D4ED8' }}>
              <strong>Como obter:</strong> Acesse{' '}
              <a href="https://www.mercadopago.com.br/developers/panel/app" target="_blank" rel="noreferrer" style={{ color:'#2563EB' }}>
                mercadopago.com.br/developers
              </a>
              {' '}→ Suas integrações → Credenciais de produção.
            </div>

            <form onSubmit={saveMp}>
              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Modo</label>
                <div style={{ display:'flex', gap:12 }}>
                  {[['production','Produção (cobranças reais)'],['sandbox','Sandbox (testes)']].map(([v,l]) => (
                    <label key={v} style={{ display:'flex', alignItems:'center', gap:6, cursor:'pointer', fontWeight: mp.mp_mode===v?700:400,
                      color: mp.mp_mode===v?'#2563EB':'#374151', fontSize:'.9rem' }}>
                      <input type="radio" name="mp_mode" value={v} checked={mp.mp_mode===v} onChange={()=>setMp(m=>({...m,mp_mode:v}))} />
                      {l}
                    </label>
                  ))}
                </div>
              </div>

              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Access Token (Produção ou Teste) *</label>
                <input value={mp.mp_access_token} onChange={e=>setMp(m=>({...m,mp_access_token:e.target.value}))}
                  style={inp} placeholder={mp.mp_access_token === MASK ? 'Deixe em branco para manter' : 'APP_USR-...'} />
                <div style={{ fontSize:'.75rem', color:'#9CA3AF', marginTop:4 }}>
                  Começa com <code>APP_USR-</code> (produção) ou <code>TEST-</code> (sandbox)
                </div>
              </div>

              <div style={{ marginBottom:14 }}>
                <label style={lbl}>Public Key</label>
                <input value={mp.mp_public_key} onChange={e=>setMp(m=>({...m,mp_public_key:e.target.value}))}
                  style={inp} placeholder="APP_USR-..." />
                <div style={{ fontSize:'.75rem', color:'#9CA3AF', marginTop:4 }}>
                  Usada no frontend para checkout pro (cartão de crédito)
                </div>
              </div>

              <div style={{ marginBottom:20 }}>
                <label style={lbl}>Webhook Secret (opcional)</label>
                <input value={mp.mp_webhook_secret} onChange={e=>setMp(m=>({...m,mp_webhook_secret:e.target.value}))}
                  style={inp} placeholder={mp.mp_webhook_secret === MASK ? 'Deixe em branco para manter' : 'Segredo para validar assinatura'} />
                <div style={{ fontSize:'.75rem', color:'#9CA3AF', marginTop:4 }}>
                  Encontrado em Mercado Pago → Webhooks → Chave secreta
                </div>
              </div>

              <button type="submit" disabled={saving}
                style={{ padding:'10px 24px', background:'#2563EB', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', opacity:saving?.7:1 }}>
                {saving ? 'Salvando...' : 'Salvar Mercado Pago'}
              </button>
            </form>
          </div>

          {/* Webhook URL */}
          {status.mp_webhook_url && (
            <div style={card}>
              <h2 style={{ fontWeight:700, fontSize:'1rem', color:'#0F172A', marginBottom:4 }}>URL do Webhook</h2>
              <p style={{ color:'#6B7280', fontSize:'.85rem', marginBottom:12 }}>
                Configure esta URL no painel do Mercado Pago para receber notificações automáticas de pagamento.
              </p>
              <div style={{ display:'flex', gap:10, alignItems:'center' }}>
                <code style={{ flex:1, fontSize:'.8rem', color:'#0F172A', wordBreak:'break-all', background:'#F8FAFC', border:'1px solid #E5E7EB', borderRadius:8, padding:'10px 14px', display:'block' }}>
                  {status.mp_webhook_url}
                </code>
                <button onClick={() => { navigator.clipboard.writeText(status.mp_webhook_url); toast.success('Copiado!'); }}
                  style={{ padding:'8px 14px', background:'#F3F4F6', border:'1.5px solid #E5E7EB', borderRadius:8, cursor:'pointer', fontSize:'.8rem', fontWeight:600, flexShrink:0 }}>
                  Copiar
                </button>
              </div>
              <div style={{ fontSize:'.78rem', color:'#9CA3AF', marginTop:10 }}>
                Em Mercado Pago → Webhooks → Adicionar webhook → Cole esta URL → Ative os eventos: <strong>payment</strong>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
